import axios, { AxiosError } from "axios";

const baseUrl: string = "/api/v0/reports"

export interface ReportApi {
    getReport: (requestId: string, startDate: string, endDate: string) => Promise<Blob>;
}

const reportApi: ReportApi = {
    getReport: async (requestId: string, startDate: string, endDate: string) => {
        const { data } = await axios.get<Blob>(`${baseUrl}/${requestId}/${startDate}/${endDate}`, { responseType: "blob", silent: true });
        return data;
    },
}

export default reportApi;